export default __webpack_public_path__ + "static/media/calendar.eab5b118.svg";